import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { updateMetaTags } from "../utils/seo";
import Translate from "../components/Translate";
import RegisterPaySubscribeFlow from "../components/RegisterPaySubscribeFlow";
import PageBanner from "../components/PageBanner";

export default function PrintEmploymentNewsSubscription() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    updateMetaTags(
      `${t('print-subscription')} | ${t('site-title')}`,
      t('subscription-desc'),
      t('subscription-keywords')
    );
  }, [t, i18n.language]);
  return (
    <section className="w-full min-h-[80vh] bg-primary-50 pb-16">
      <PageBanner
        title={<Translate text="print-employment-news-subscription" />}
        subtitle={<Translate text="print-subscription-subtitle" />}
        badgeText={t('badge-print-edition')}
      />
      <div className="w-full max-w-5xl mx-auto px-4 mt-12">
        <div className="space-y-6">
          <div>
            <h2 className="text-sm sm:text-base font-semibold text-primary-700 mb-1 text-left">Q. How to subscribe print version of DPD's Employment News and Rozgar Samachar (Hindi & Urdu)?</h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 text-justify">
              You can subscribe DPD's Employment News and Rozgar Samachar (Hindi & Urdu) via <a href="http://www.employmentnews.gov.in" className="text-primary-600 underline break-all" target="_blank" rel="noopener noreferrer">www.employmentnews.gov.in</a> website. For offline subscription, prepare Demand Draft/Indian Postal Order/Money Order/Electronic Money Order (DD/IPO/MO/EMO) in favor of 'Employment News, Govt. of India' payable in New Delhi and send it with your complete postal address, pin code, and mobile number to: <br />
              <span className="block mt-2 font-medium">Employment News, Publications Division, 7th Floor, Soochna Bhawan, Lodhi Road, New Delhi-110003</span>
            </p>
          </div>
          <div>
            <h2 className="text-sm sm:text-base font-semibold text-primary-700 mb-1 text-left">Q. What are the subscription charges for DPD's Journals?</h2>
            <div className="overflow-x-auto">
              <table className="min-w-[320px] w-full border border-primary-200 rounded-lg shadow text-center bg-white mb-2">
                <caption className="sr-only">Subscription charges for Print and e-Version plans</caption>
                <thead>
                  <tr className="bg-primary-700 text-white">
                    <th scope="col" className="py-2 px-1 sm:px-2 text-xs sm:text-sm font-semibold">Plan</th>
                    <th scope="col" className="py-2 px-1 sm:px-2 text-xs sm:text-sm font-semibold">Print<br />(Ordinary)</th>
                    <th scope="col" className="py-2 px-1 sm:px-2 text-xs sm:text-sm font-semibold">Print<br />(Tracking)</th>
                    <th scope="col" className="py-2 px-1 sm:px-2 text-xs sm:text-sm font-semibold">e-Version</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="odd:bg-primary-50">
                    <th scope="row" className="py-2 px-1 sm:px-2 text-xs sm:text-sm font-normal">6 Months</th>
                    <td className="py-2 px-1 sm:px-2 text-xs sm:text-sm">Rs. 265/-</td>
                    <td className="py-2 px-1 sm:px-2 text-xs sm:text-sm">Rs. 650/-</td>
                    <td className="py-2 px-1 sm:px-2 text-xs sm:text-sm">Rs. 200/-</td>
                  </tr>
                  <tr className="odd:bg-primary-50">
                    <th scope="row" className="py-2 px-1 sm:px-2 text-xs sm:text-sm font-normal">1 Year</th>
                    <td className="py-2 px-1 sm:px-2 text-xs sm:text-sm">Rs. 530/-</td>
                    <td className="py-2 px-1 sm:px-2 text-xs sm:text-sm">Rs. 1250/-</td>
                    <td className="py-2 px-1 sm:px-2 text-xs sm:text-sm">Rs. 400/-</td>
                  </tr>
                  <tr className="odd:bg-primary-50">
                    <th scope="row" className="py-2 px-1 sm:px-2 text-xs sm:text-sm font-normal">2 Years</th>
                    <td className="py-2 px-1 sm:px-2 text-xs sm:text-sm">Rs. 1000/-</td>
                    <td className="py-2 px-1 sm:px-2 text-xs sm:text-sm">Rs. 2450/-</td>
                    <td className="py-2 px-1 sm:px-2 text-xs sm:text-sm">Rs. 750/-</td>
                  </tr>
                  <tr className="odd:bg-primary-50">
                    <th scope="row" className="py-2 px-1 sm:px-2 text-xs sm:text-sm font-normal">3 Years</th>
                    <td className="py-2 px-1 sm:px-2 text-xs sm:text-sm">Rs. 1400/-</td>
                    <td className="py-2 px-1 sm:px-2 text-xs sm:text-sm">Rs. 3600/-</td>
                    <td className="py-2 px-1 sm:px-2 text-xs sm:text-sm">Rs. 1050/-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <h2 className="text-sm sm:text-base font-semibold text-primary-700 mb-1 text-left">Q. After successfully taken subscription when will I receive the Employment News/Rozgar Samachar (Hindi & Urdu)?</h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-800 text-justify">
              Every Friday the print order for Employment News is finalized. If you subscribe between Monday and Thursday, you will start receiving copies from Saturday of the next week. If you subscribe between Friday and Sunday, delivery will commence from the next to next Saturday. For example, if you subscribe on 08.08.2024 (Thursday), supply starts from 24.08.2024.
            </p>
          </div>
          <div>
            <h2 className="text-sm sm:text-base font-semibold text-primary-700 mb-1 text-left">Q. Can I change/update my address/contact number/language during the subscription period?</h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-800 text-justify">
              Yes, you can update your address/language/contact number during your subscription by logging in with your username and password to update online. Once updated, inform us via email at <a href="mailto:director.employmentnews@gmail.com" className="text-primary-600 underline break-all">director.employmentnews@gmail.com</a> with your Order No. (PRV/EN202_________). Offline subscribers can email their Subscription No., old address, and new address for updates. For language change, email your subscription details.
            </p>
          </div>
          <div>
            <h2 className="text-sm sm:text-base font-semibold text-primary-700 mb-1 text-left">Q. What is the mode of dispatch for Employment News/Rozgar Samachar (Hindi & Urdu)?</h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-800 text-justify">
              After successful subscription, Employment News/Rozgar Samachar is delivered via Ordinary/Magazine Post by the Department of Posts.
            </p>
          </div>
          <div>
            <h2 className="text-sm sm:text-base font-semibold text-primary-700 mb-1 text-left">Q. In case of non-receipt of journal where to contact?</h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-800 text-justify">
              First, contact your nearest/local post office. If unresolved, email <a href="mailto:director.employmentnews@gmail.com" className="text-primary-600 underline break-all">director.employmentnews@gmail.com</a> or call 011-24365610 with your details.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
